import { useConditions } from 'mailup-react-helpers'
import {
  Flex,
  FlexItem,
  Panel,
  Text,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import InputNotes from './components/InputNotes'
import InputPreHeader from './components/InputPreHeader'
import InputSubject from './components/InputSubject'
import InputTags from './components/InputTags'

const BoxInput = () => {
  const { id } = useParams()
  const intl = useIntl()

  const [hasTags] = useConditions(['uo:TAG AND co:TAG'])

  return (
    <>
      <Panel>
        <Flex flexDirection='column' rowGap='24px'>
          <FlexItem>
            <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
              {intl.formatMessage({ id: 'Load.MailupCommon.Id' })}
            </Text>{' '}
            {id}
          </FlexItem>
          <FlexItem>
            <InputSubject />
          </FlexItem>
          <FlexItem>
            <InputPreHeader />
          </FlexItem>
          <FlexItem>
            <InputNotes />
          </FlexItem>
          {hasTags && (
            <FlexItem>
              <InputTags />
            </FlexItem>
          )}
        </Flex>
      </Panel>
    </>
  )
}

export default BoxInput
